import { toast } from "sonner";

/**
 * Read-only "View as company" (platform operators). While active, the app
 * reads the viewed company's data (the database switches the operator's org
 * for read requests only) and every write from the UI is refused here first.
 */
let activeView: { orgId: number; orgName: string } | null = null;

export const setActiveViewAsCompany = (
  view: { orgId: number; orgName: string } | null,
) => {
  activeView = view;
};

export const getActiveViewAsCompany = () => activeView;

export class ViewAsCompanyReadOnlyError extends Error {
  constructor() {
    super(
      `Read-only: you're viewing as ${activeView?.orgName ?? "another company"}. Exit view mode to make changes.`,
    );
    this.name = "ViewAsCompanyReadOnlyError";
  }
}

export const assertNotViewingAsCompany = () => {
  if (!activeView) return;
  const error = new ViewAsCompanyReadOnlyError();
  // Screens often show their own generic "failed" message; say why once.
  toast.warning(error.message, { id: "view-as-company-read-only" });
  throw error;
};
